import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const translations = {
  it: {
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.census': 'Produzione',
    'nav.leaderboard': 'Classifica',
    'nav.team': 'Team',
    'nav.offices': 'Uffici',
    'nav.practices': 'Pratiche',
    'nav.challenges': 'Sfide',
    'nav.notifications': 'Notifiche',
    'nav.training': 'Formazione',
    'nav.subscription': 'Abbonamento',
    'nav.maps': 'Mappa',
    'nav.settings': 'Impostazioni',
    'nav.support': 'Supporto',
    'nav.logout': 'Esci',

    // Dashboard
    'dash.hello': 'Ciao',
    'dash.office': 'Ufficio',
    'dash.challenge': 'Sfida',
    'dash.new_news': 'Nuova Notizia',
    'dash.level': 'Livello',
    'dash.rank': 'Rank',
    'dash.points': 'Punti',
    'dash.monthly_obj': 'Obiettivi Mensili',
    'dash.close': 'Chiudi',
    'dash.edit': 'Modifica',
    'dash.set': 'Imposta',
    'dash.set_objectives_msg': 'Imposta i tuoi obiettivi per questo mese',
    'dash.no_objectives': 'Nessun obiettivo mensile impostato',
    'dash.no_objectives_sub': 'Clicca "Imposta" per definire i tuoi obiettivi di produzione',
    'dash.save_objectives': 'Salva Obiettivi',
    'dash.saving': 'Salvataggio...',
    'dash.objectives_saved': 'Obiettivi salvati!',
    'dash.objectives_error': 'Errore nel salvataggio obiettivi',
    'dash.active_challenges': 'Sfide Attive',
    'dash.all_challenges': 'Tutte le sfide',
    'dash.top_producers': 'Top Produttori',
    'dash.full_ranking': 'Classifica completa',
    'dash.you': '(Tu)',
    'dash.no_producers': 'Nessun produttore',
    'dash.certified': 'Certificato',

    // KPI labels
    'kpi.notizie': 'Notizie',
    'kpi.cdv': 'CDV',
    'kpi.incarichi': 'Incarichi',
    'kpi.ribassi': 'Ribassi',
    'kpi.vendite': 'Vendite',
    'kpi.valutazioni': 'Valutazioni',

    // Settings
    'settings.title': 'Impostazioni',
    'settings.subtitle': 'Gestisci il tuo profilo e le preferenze',
    'settings.profile': 'Profilo',
    'settings.company': 'Azienda',
    'settings.name': 'Nome',
    'settings.email': 'Email',
    'settings.role': 'Ruolo',
    'settings.company_name': 'Nome Azienda',
    'settings.company_code': 'Codice Azienda',
    'settings.share_code': 'Condividi questo codice con i membri del tuo team',
    'settings.stats': 'Statistiche',
    'settings.production': 'Produzione',
    'settings.change_avatar': 'Clicca sull\'immagine per cambiare avatar',
    'settings.code_copied': 'Codice copiato!',
    'settings.image_only': 'Solo immagini consentite',
    'settings.image_too_big': 'Immagine troppo grande (max 5MB)',
    'settings.image_updated': 'Immagine profilo aggiornata!',
    'settings.image_error': 'Errore nel caricamento immagine',
    'settings.language': 'Lingua',
    'settings.language_subtitle': 'Seleziona la lingua dell\'applicazione',

    // Training
    'training.title': 'Area Formativa',
    'training.subtitle': 'Corsi e moduli per la formazione del team',
    'training.new_module': 'Nuovo Modulo',
    'training.your_progress': 'Il tuo progresso formativo',
    'training.completed': 'completati',
    'training.mandatory': 'Obbligatori',
    'training.all': 'Tutti',
    'training.no_modules': 'Nessun modulo formativo disponibile',
    'training.title_required': 'Titolo obbligatorio',
    'training.module_created': 'Modulo creato',
    'training.module_updated': 'Modulo aggiornato',
    'training.module_deleted': 'Modulo eliminato',
    'training.save_error': 'Errore nel salvataggio',
    'training.delete_confirm': 'Eliminare questo modulo?',
    'training.mark_complete': 'Segna come completato',
    'training.team_progress': 'Progresso Team',
    'training.no_operators': 'Nessun operatore nel team',
    'training.quiz': 'Quiz',
    'training.questions': 'domande',
    'training.answer_all': 'Rispondi a tutte le domande',
    'training.submit_answers': 'Invia Risposte',
    'training.score': 'Punteggio',
    'training.passed': 'Superato!',
    'training.retry': 'Riprova!',
    'training.last_score': 'Ultimo punteggio quiz',
    'training.upload_pdf': 'Carica PDF',
    'training.download_pdf': 'Scarica PDF',
    'training.pdf_uploaded': 'PDF caricato con successo',
    'training.pdf_error': 'Errore nel caricamento PDF',
    'training.mandatory_tag': 'Obbligatorio',

    // AI Assistant
    'ai.title': 'Assistente AI',
    'ai.subtitle': 'Il tuo coach personale con dati in tempo reale',
    'ai.placeholder': 'Chiedimi qualcosa...',
    'ai.welcome': 'Come posso aiutarti oggi? Ho accesso ai dati di produzione di tutti gli uffici e posso darti consigli personalizzati.',
    'ai.error': 'Mi dispiace, si e\' verificato un errore. Riprova tra poco.',
    'ai.new_chat': 'Nuova Chat',
    'ai.quick_q1': 'Come sta andando la mia produzione?',
    'ai.quick_q2': 'Chi sono i top produttori?',
    'ai.quick_q3': 'Come posso migliorare il mio punteggio?',
    'ai.quick_q4': 'Analizza le performance degli uffici',

    // User Profile
    'profile.title': 'Profilo Utente',
    'profile.office': 'Ufficio',
    'profile.production': 'Produzione Totale',
    'profile.month_stats': 'Statistiche Mese Corrente',
    'profile.stories': 'Storie',
    'profile.no_stories': 'Nessuna storia attiva',
    'profile.close': 'Chiudi',

    // Common
    'common.save': 'Salva',
    'common.cancel': 'Annulla',
    'common.delete': 'Elimina',
    'common.edit': 'Modifica',
    'common.loading': 'Caricamento...',
    'common.error': 'Errore',
    'common.vs': 'vs',
  },
  en: {
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.census': 'Census',
    'nav.leaderboard': 'Leaderboard',
    'nav.team': 'Team',
    'nav.offices': 'Offices',
    'nav.practices': 'Practices',
    'nav.challenges': 'Challenges',
    'nav.notifications': 'Notifications',
    'nav.training': 'Training',
    'nav.subscription': 'Subscription',
    'nav.maps': 'Map',
    'nav.settings': 'Settings',
    'nav.support': 'Support',
    'nav.logout': 'Logout',

    // Dashboard
    'dash.hello': 'Hello',
    'dash.office': 'Office',
    'dash.challenge': 'Challenge',
    'dash.new_news': 'New Lead',
    'dash.level': 'Level',
    'dash.rank': 'Rank',
    'dash.points': 'Points',
    'dash.monthly_obj': 'Monthly Objectives',
    'dash.close': 'Close',
    'dash.edit': 'Edit',
    'dash.set': 'Set',
    'dash.set_objectives_msg': 'Set your objectives for this month',
    'dash.no_objectives': 'No monthly objectives set',
    'dash.no_objectives_sub': 'Click "Set" to define your production objectives',
    'dash.save_objectives': 'Save Objectives',
    'dash.saving': 'Saving...',
    'dash.objectives_saved': 'Objectives saved!',
    'dash.objectives_error': 'Error saving objectives',
    'dash.active_challenges': 'Active Challenges',
    'dash.all_challenges': 'All challenges',
    'dash.top_producers': 'Top Producers',
    'dash.full_ranking': 'Full ranking',
    'dash.you': '(You)',
    'dash.no_producers': 'No producers',
    'dash.certified': 'Certified',

    // KPI labels
    'kpi.notizie': 'Leads',
    'kpi.cdv': 'Valuations',
    'kpi.incarichi': 'Contracts',
    'kpi.ribassi': 'Reductions',
    'kpi.vendite': 'Sales',
    'kpi.valutazioni': 'Valuations',

    // Settings
    'settings.title': 'Settings',
    'settings.subtitle': 'Manage your profile and preferences',
    'settings.profile': 'Profile',
    'settings.company': 'Company',
    'settings.name': 'Name',
    'settings.email': 'Email',
    'settings.role': 'Role',
    'settings.company_name': 'Company Name',
    'settings.company_code': 'Company Code',
    'settings.share_code': 'Share this code with your team members',
    'settings.stats': 'Statistics',
    'settings.production': 'Production',
    'settings.change_avatar': 'Click the image to change avatar',
    'settings.code_copied': 'Code copied!',
    'settings.image_only': 'Images only',
    'settings.image_too_big': 'Image too large (max 5MB)',
    'settings.image_updated': 'Profile image updated!',
    'settings.image_error': 'Error uploading image',
    'settings.language': 'Language',
    'settings.language_subtitle': 'Select the application language',

    // Training
    'training.title': 'Training Area',
    'training.subtitle': 'Courses and modules for team training',
    'training.new_module': 'New Module',
    'training.your_progress': 'Your training progress',
    'training.completed': 'completed',
    'training.mandatory': 'Mandatory',
    'training.all': 'All',
    'training.no_modules': 'No training modules available',
    'training.title_required': 'Title required',
    'training.module_created': 'Module created',
    'training.module_updated': 'Module updated',
    'training.module_deleted': 'Module deleted',
    'training.save_error': 'Error saving',
    'training.delete_confirm': 'Delete this module?',
    'training.mark_complete': 'Mark as completed',
    'training.team_progress': 'Team Progress',
    'training.no_operators': 'No operators in the team',
    'training.quiz': 'Quiz',
    'training.questions': 'questions',
    'training.answer_all': 'Answer all questions',
    'training.submit_answers': 'Submit Answers',
    'training.score': 'Score',
    'training.passed': 'Passed!',
    'training.retry': 'Try again!',
    'training.last_score': 'Last quiz score',
    'training.upload_pdf': 'Upload PDF',
    'training.download_pdf': 'Download PDF',
    'training.pdf_uploaded': 'PDF uploaded successfully',
    'training.pdf_error': 'Error uploading PDF',
    'training.mandatory_tag': 'Mandatory',

    // AI Assistant
    'ai.title': 'AI Assistant',
    'ai.subtitle': 'Your personal coach with real-time data',
    'ai.placeholder': 'Ask me something...',
    'ai.welcome': 'How can I help you today? I have access to all office production data and can give you personalized advice.',
    'ai.error': 'Sorry, an error occurred. Please try again shortly.',
    'ai.new_chat': 'New Chat',
    'ai.quick_q1': 'How is my production going?',
    'ai.quick_q2': 'Who are the top producers?',
    'ai.quick_q3': 'How can I improve my score?',
    'ai.quick_q4': 'Analyze office performances',

    // User Profile
    'profile.title': 'User Profile',
    'profile.office': 'Office',
    'profile.production': 'Total Production',
    'profile.month_stats': 'Current Month Stats',
    'profile.stories': 'Stories',
    'profile.no_stories': 'No active stories',
    'profile.close': 'Close',

    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.vs': 'vs',
  }
};

const I18nContext = createContext(null);

export const useI18n = () => useContext(I18nContext);

export const I18nProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => localStorage.getItem('sanqui_lang') || 'it');

  const t = useCallback((key) => {
    return translations[locale]?.[key] || translations['it']?.[key] || key;
  }, [locale]);

  const changeLocale = useCallback((newLocale) => {
    setLocale(newLocale);
    localStorage.setItem('sanqui_lang', newLocale);
  }, []);

  return (
    <I18nContext.Provider value={{ locale, t, changeLocale }}>
      {children}
    </I18nContext.Provider>
  );
};
